import * as React from "react";

import { cn } from "@/lib/utils";
import { NvCheckIcon } from "./nv-icons";

// Figma checkbox (18 x 18, r2): checked = #FD5108 fill with a white ✓ (ver.6, 회원가입 약관 · Agent Finder 필터).
export interface NvCheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "onChange"> {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label?: React.ReactNode;
  labelClassName?: string;
  // 체크 상자(18 x 18)에 덧붙일 클래스 — 화면별로 선 색만 바꿀 때 (예: Case Study 목록 ver.7 미선택 선 #CBD1D6)
  boxClassName?: string;
  // dark = Case Study 산업 필터 (203:9123): checked #1A1C21, unchecked 1.5px #BFC2C7
  tone?: "brand" | "dark";
}

function NvCheckbox({ checked, onCheckedChange, label, labelClassName, boxClassName, tone = "brand", className, disabled, id, ...props }: NvCheckboxProps) {
  const autoId = React.useId();
  const inputId = id ?? autoId;
  return (
    <label htmlFor={inputId} className={cn("inline-flex cursor-pointer items-center gap-[10px]", disabled && "cursor-default opacity-50", className)}>
      <input
        id={inputId}
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onCheckedChange(e.target.checked)}
        {...props}
      />
      <span
        aria-hidden
        className={cn(
          "flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-nv-xs text-nv-text-inverse peer-focus-visible:ring-2 peer-focus-visible:ring-nv-brand peer-focus-visible:ring-offset-1",
          tone === "dark"
            ? checked
              ? "bg-nv-text-primary"
              : "border-[1.5px] border-[#BFC2C7] bg-nv-surface"
            : checked
              ? "bg-nv-brand"
              : "border border-nv-border-strong bg-nv-surface",
          boxClassName,
        )}
      >
        {checked &&
          (tone === "dark" ? (
            <svg width={18} height={18} viewBox="0 0 18 18" fill="none">
              <path d="M5.5 9.29167L7.83333 11.625L12.5 6.375" stroke="white" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            <NvCheckIcon size={14} />
          ))}
      </span>
      {label && <span className={cn("text-[14px] leading-[17px] text-nv-text-primary", labelClassName)}>{label}</span>}
    </label>
  );
}

export { NvCheckbox };
